import { useCallback, useEffect, useRef, useState } from 'react';
import { forgetAuthNotice, peekAuthNotice } from '@/modules/auth/authNotice';
import type { AuthStatus, AuthStatusTone } from './AuthShell';

const SUCCESS_SHOWN_MS = 6_000;

export function useAuthStatus() {
  const [status, setStatus] = useState<AuthStatus | null>(peekAuthNotice);
  useEffect(forgetAuthNotice, []);
  const timer = useRef<ReturnType<typeof setTimeout>>();
  useEffect(() => () => clearTimeout(timer.current), []);

  const show = useCallback((message: string, tone: AuthStatusTone = 'error') => {
    clearTimeout(timer.current);
    setStatus({ message, tone });
    if (tone === 'success') timer.current = setTimeout(() => setStatus(null), SUCCESS_SHOWN_MS);
  }, []);

  const clearError = useCallback(() => {
    setStatus(current => (current?.tone === 'error' ? null : current));
  }, []);

  return { status, show, clearError };
}
